require('./quad-view.component.scss');
import {
  PATH_STRING_SEPARATOR
} from '../../common/config.js';


class QuadViewController {
  constructor(
    $scope,
    $timeout,
    $element,
    FrameLoadService,
    AggregateDataService,
    RouterService,
  ) {
    this.sep = PATH_STRING_SEPARATOR;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$element = $element;
    this.AggregateDataService = AggregateDataService;
    this.router = RouterService;
    this.maxFrameInndex = -1;
    this.$scope.$watch('$ctrl.AggregateDataService.remoteUsers', () => {
      this.frames = this.getFrames();
    });
    this.frames = this.getFrames();
  }

  maximizeToggle(e, i) {
    this.maxFrameInndex = this.maxFrameInndex == -1 ? i : -1;
    this.$scope.$apply();
  }

  get framesQty() {
    if (this.AggregateDataService.remoteUsers.length < 3) return this.AggregateDataService.remoteUsers.length;
    if (this.AggregateDataService.remoteUsers.length < 5) return 4;
    if (this.AggregateDataService.remoteUsers.length < 7) return 6;
    if (this.AggregateDataService.remoteUsers.length < 9) return 8;
    if (this.AggregateDataService.remoteUsers.length < 13) return 12;
    return 15;
  }

  removeFrame(frame) {
    if (this.AggregateDataService.allRemoteUsers.length <= 1) return;
    this.AggregateDataService.allRemoteUsers = this.AggregateDataService.allRemoteUsers.filter(u => !(
      u.hwid === frame.hwid && u.sid === frame.sid));
    this.AggregateDataService.updateRemoteUsers();
    if (!this.$scope.$root.$$phase) this.$scope.$digest();
  }

  getFrames() {
    const frames = [];
    const maxLen = this.framesQty;
    // let i = 0;
    this.AggregateDataService.remoteUsers.forEach((u, i) => {
      if (i >= maxLen) return;
      let name = u['full_name'] ? `${u.user} (${u['full_name']})` : u.user;
      if (u['computer_name']) name = `${u['computer_name']} -> ${name}`;
      frames.push({
        index: u.index,
        name: name,
        uName: u.user,
        hwid: u.hwid,
        computer: u.computer,
        sid: u.sid,
        url: '/remote/?hwid=' + u.hwid + '/' + u.sid,
      });
    });

    frames.fill({
      name: null,
      url: null
    }, this.AggregateDataService.remoteUsers.length, maxLen);
    return frames.sort((a, b) => b.index - a.index);
  }

  frameClass(i) {
    // return 'size-' + this.framesQty;
    if (this.maxFrameInndex === -1) return 'size-' + this.framesQty;
    return this.maxFrameInndex === i ? 'size-1' : 'size-0';
  }

  setFrameQuard(frame) {
    const frameWindow = this.$element.find(`#id_remote_frame_${frame.index} iframe`);
    if (!frameWindow.length) return;
    frame.content = frameWindow[0].contentWindow;
    frame.content.quard = this;
    frame.content.quardFrame = frame;
  }

  onFrameLoad(frame) {
    this.setFrameQuard(frame);
  }

  toggleWindow(frame) {
    this.maxFrameInndex = this.maxFrameInndex == -1 ? frame.index : -1;
    this.$scope.$digest();
  }

}

export const QuadViewComponent = {
  template: require('./quad-view.component.html'),
  bindings: {},
  controller: QuadViewController,
};



// WEBPACK FOOTER //
// ./src/view/quad-frames/quad-view.component.js